<template>
  <div>
    <v-card>
      <v-card-title>Add breaking news</v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form" v-model="isValid">
          <v-text-field
            filled
            label="Title"
            v-bind:rules="validation.title"
            v-model="newsData.title"
          ></v-text-field>

          <redactor v-model="newsData.body"></redactor>
          <br />
          <v-autocomplete
            filled
            required
            autocomplete="off"
            label="Select Category"
            v-model="newsData.category_id"
            item-text="name"
            :rules="validation.category"
            item-value="id"
            v-bind:items="category"
          ></v-autocomplete>
          <v-card class="my-2">
            <v-card-title>
              Add tag (optional)
            </v-card-title>
            <v-card-text>
              <v-combobox
                v-model="newsData.content_tag"
                chips
                outlined
                clearable
                label="Add tag and press enter"
                multiple
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    aria-multiline="true"
                    @click="select"
                    @click:close="removeContentTag(item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-card-text>
          </v-card>
          <v-card tile>
            <v-card-title>
              Images
            </v-card-title>
            <v-card-text>
              <v-file-input
                filled
                label="Photo"
                accept="image/*"
                prepend-icon="mdi-camera"
                :clearable="false"
                v-model="imageData"
                multiple
                @change="imageInputChangedCallback"
              >
                <template v-slot:selection> </template>
              </v-file-input>
              <div
                v-if="
                  selectedImages !== null &&
                    Array.isArray(selectedImages) &&
                    selectedImages.length > 0
                "
              >
                <file-images
                  :images="selectedImages"
                  @delete_success="offlineImageDeleteCallback"
                />
              </div>
            </v-card-text>
          </v-card>
          <br />
          <v-card>
            <v-card-title>
              Body Image
            </v-card-title>
            <v-file-input
              filled
              class="pa-4"
              label="Browse"
              accept="image/*"
              prepend-icon="mdi-image-album"
              hide-details
              @change="bodyImageInputChangedCallback"
            >
              <template v-slot:selection> </template>
            </v-file-input>
            <div
              v-if="
                selectedBodyImages !== null &&
                  Array.isArray(selectedBodyImages) &&
                  selectedBodyImages.length > 0
              "
            >
              <file-images
                :images="selectedBodyImages"
                @delete_success="offlineBodyImageDeleteCallback"
              />
            </div>
          </v-card>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
          tile
          color="primary"
          class="mx-2"
          v-on:click="submit"
          :disabled="!isValid"
          v-bind:loading="loading"
          >Submit</v-btn
        >
        <v-spacer />
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import postApi from '@/api/postApi'
import breakingNewsApi from '@/api/breakingNewsApi'
import snackbar from '@/utils/snackbar'
import redactor from '@/components/Redactor.vue'
export default {
  components: {
    'file-images': () => import('@/components/ImagesFromFiles'),
    redactor
  },
  props: {
    title: {
      type: String,
      default: 'Add News'
    }
  },
  mounted () {
    this.init()
  },
  computed: {},

  data () {
    return {
      isValid: null,
      serverImages: [],
      selectedImages: [],
      loading: false,
      category: null,
      imageData: null,
      selectedBodyImages: [],
      newsData: {
        title: '',
        body: '',
        body_image: null,
        images: [],
        category_id: null,
        content_tag: null,
        tag: null
      },
      validation: {
        title: [v => !!v || 'Please enter title'],
        category: [v => !!v || 'Please select category']
      }
    }
  },
  watch: {
    'newsData.title': function (newVal, oldVal) {
      if (newVal && newVal && newVal[newVal.length - 1] === '\\') {
        this.newsData.title = oldVal !== null ? oldVal + 'ṭ' : 'ṭ'
      } else if (newVal && newVal[newVal.length - 1] === '|') {
        this.newsData.title = oldVal + 'Ṭ'
      }
    }
  },
  methods: {
    removeContentTag (item) {
      this.newsData.content_tag.splice(
        this.newsData.content_tag.indexOf(item),
        1
      )
    },
    offlineImageDeleteCallback (data) {
      // clear file input view
      this.imageData = null
      const index = this.selectedImages.indexOf(data.file)
      if (index !== undefined && index !== null) {
        if (index > -1) {
          this.selectedImages.splice(index, 1)
        }
      }
    },

    async imageInputChangedCallback (file) {
      this.$log.info('@Add brekaing news input image calllback')
      if (file == null) {
        // this.selectedImages = []
        return
      }

      file.forEach(element => {
        this.newsData.images.push(element)
        const reader = new FileReader()
        reader.onload = e => this.selectedImages.push(e.target.result)
        reader.readAsDataURL(element)
      })
    },
    async bodyImageInputChangedCallback (file) {
      this.newsData.body_image = file

      if (file == null) {
        // this.selectedImages = []
        return
      }

      const reader = new FileReader()
      reader.onload = e => this.selectedBodyImages.push(e.target.result)
      reader.readAsDataURL(file)
    },
    offlineBodyImageDeleteCallback (data) {
      const index = this.selectedBodyImages.indexOf(data.file)
      if (index !== undefined && index !== null) {
        if (index > -1) {
          this.selectedBodyImages.splice(index, 1)
        }
      }
    },
    async init () {
      const response = await postApi.getCategories()
      if (response.data !== undefined) {
        this.category = response.data
      }
    },
    async submit () {
      if (this.newsData.body === '') {
        snackbar.show('Please enter body', 'error')
        return
      }
      this.loading = true
      try {
        if (this.newsData.content_tag) {
          this.newsData.tag = this.newsData.content_tag.join(' § ') // option key + 5
        }
        this.$log.info('insert new params', [this.newsData])
        const response = await breakingNewsApi.store(this.newsData)
        this.$log.info('breaking news response ', [response])
        if (response.data !== undefined) {
          this.$refs.form.reset()
          snackbar.show('Breaking News added successfully', 'success')
          window.publish_date = response.data.publish_date
          this.$router.push({ path: '/breaking-news', replace: true })
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
.ql-editor {
  min-height: 350px;
  font-size: 15px;
}
</style>
